import { useEffect } from 'react'
import { useTheme as useNextTheme } from 'next-themes'
import { parseThemeParam, isInAppWebView, resolveAutoTheme } from 'utils/theme'

const STORAGE_KEY = 'mac-swap-theme'

// When the user has no explicit stored choice, apply ?theme= / in-app default once on mount.
// next-themes handles localStorage + system; this layers the URL param and in-app dark default.
const InAppThemeSync = () => {
  const { setTheme } = useNextTheme()
  useEffect(() => {
    if (typeof window === 'undefined') return
    const stored = window.localStorage.getItem(STORAGE_KEY)
    if (stored === 'light' || stored === 'dark') return // explicit choice wins
    const urlParam = parseThemeParam(window.location.search)
    const inApp = isInAppWebView(window.navigator, window as unknown as { ethereum?: unknown })
    const prefersDark = window.matchMedia?.('(prefers-color-scheme: dark)').matches ?? false
    setTheme(resolveAutoTheme({ urlParam, inApp, prefersDark }))
  }, [setTheme])
  return null
}

export default InAppThemeSync
